/**
 * Mappings from technical Node IDs to Human-Readable Titles.
 */
export const NODE_TITLE_MAPPING = {
    "aiAgentNode": "AI Agent",
    "upload_node": "File/URL Loader",
    "fileIONode": "File/URL Extractor",
    "ReportNode": "File Creation Node",
    "outputNode": "Response Node",
    "inputNode": "Chat Trigger",
    "webhookTriggerNode": "Webhook Trigger",
    "scheduleTriggerNode": "Schedule Trigger",
    "outlookTriggerNode": "Outlook Trigger",
    "unifiedLlmNode": "Custom LLM",
    "openAiGptNode": "OpenAI GPT",
    "bytePlusNode": "BytePlus Skylark",
    "groqNode": "Groq",
    "wiizLLMNode": "WiiZ LLM",
    "openAiEmbeddingNode": "OpenAI Embedding",
    "bytePlusEmbeddingNode": "BytePlus Embedding",
    "embeddingNode": "Sentence Transformer",
    "itiNode": "Image to Image",
    "ocrNode": "OCR",
    "textToSpeechNode": "Text To Speech",
    "speechToTextNode": "Speech-to-Text",
    "vlmNode": "VLM",
    "chunkingNode": "Chunking",
    "apiNode": "API Call",
    "filterNode": "Filter",
    "matchNode": "Match Node",
    "apiCallToolNode": "API Call Tool",
    "wikipediaScraperToolNode": "Web Scraper Tool",
    "ocrToolNode": "OCR Tool",
    "outlookToolNode": "Outlook Tool",
    "universalMcpAdapterNode": "MCP Tool",
    "aiAgentToolNode": "AI Agent Tool",
    "outlookNode": "Outlook",
    "jupyterExecutorNode": "Python Executor",
    "milvusNode": "Milvus",
    "pineconeNode": "Pinecone",
    "customVectorDbNode": "Custom Vector DB",
    "MySQLNode": "MySQL",
    "pgSqlNode": "PostgreSQL",
    "MongoDBNode": "MongoDB",
    "supabaseNode": "Supabase",
    "IfNode": "If/Else",
    "switchNode": "Switch",
    "promptValidatorNode": "Prompt Validator",
    "promptGuardrailNode": "Prompt Guardrail",
    "generationGuardrailNode": "Generation Guardrail",
    "inputGuardrailNode": "Input Guardrail",
    "retrievalGuardrailNode": "Retrieval Guardrail",
    "humanInLoopNode": "Human in the Loop"
};

/**
 * Returns the human-readable title for a given node ID.
 * Falls back to the original ID if no mapping is found.
 * @param {string} nodeId - The technical node ID.
 * @returns {string} - Human-readable title or original ID.
 */
export const getNodeTitle = (nodeId) => {
    if (!nodeId) return "";
    const key = String(nodeId).trim();
    // Try exact match
    if (NODE_TITLE_MAPPING[key]) return NODE_TITLE_MAPPING[key];

    // Try case-insensitive match (unlikely but safe)
    const lowerKey = key.toLowerCase();
    const mapEntry = Object.keys(NODE_TITLE_MAPPING).find(k => k.toLowerCase() === lowerKey);
    return mapEntry ? NODE_TITLE_MAPPING[mapEntry] : key;
};
